module.exports = __webpack_public_path__ + "static/newsletter-crop1-6c0e583d2e910fd493a52f8401def014.jpg";